import React from 'react'
import { RealtimeAI } from '@components/teachV2/RealtimeAI';

export default function RealtimeAIBeta() {

  return (
    <RealtimeAI />
  );
}
